/* eslint-disable prettier/prettier */
import React from 'react'
import { Box, Text } from '@clear/design-system'
import useMedia from 'use-media'
import { LAYOUT_BREAKPOINT } from '@styles/theme'

const AuthHeader = () => {
  const isDesktopLayout = useMedia({ minWidth: LAYOUT_BREAKPOINT })

  return (
    <Box
      data-testid="auth-page-header"
      className="relative w-full overflow-hidden flex flex-col"
    >
      <Box
        className="relative bg-blue-800 left-1/2 transform -translate-x-1/2 flex flex-col justify-center"
        style={{
          width: 'max(1628px, 120vw)',
          height: 'max(350px, 15vw)',
          maxWidth: 'none',
          borderRadius: '0 0 50% 50%',
          marginTop: '-100px',
        }}
      >
        <div className="text-center w-full max-w-7xl mx-auto text-white pt-12 px-6 md:pt-8 md:px-4">
          <Box marginBottom={4}>
            <img
              className="pt-6 pb-2 mx-auto"
              style={{
                width: 'max(300px, 15vw)',
              }}
              src="tsa-pre-logo-auth-white.svg"
              alt="TSA pre-check with CLEAR logo"
            />
          </Box>
          <Text
            as="p"
            fontWeight={600}
            lineHeight={2}
            className="text-sm md:text-3xl lg:text-4xl sm:text-xl leading-tight"
          >
            Get TSA PreCheck<sup>®</sup> for Expedited Security Screening
          </Text>
          <Text
            as="div"
            fontWeight={400}
            lineHeight={2}
            px={2}
            className="text-xs md:text-xl sm:text-lg leading-relaxed"
          >
            Pre-enroll or renew online in as little as 5 minutes.{' '}
            {!isDesktopLayout ? <br /> : ''} Valid for five years across 200+
            airports.
          </Text>
        </div>
      </Box>
    </Box>
  )
}

export default AuthHeader
